var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "label/attention",
    transform: "translate(-3.000000, -3.000000)",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.2,10.8 L10.8,10.8 L10.8,6 L9.2,6 L9.2,10.8 Z M10.798,14.308 L9.197,14.308 L9.197,12.708 L9.298,12.708 L10.698,12.708 L10.798,12.708 L10.798,14.308 Z M10,3 C6.136,3 3,6.136 3,10 C3,13.864 6.136,17 10,17 C13.864,17 17,13.864 17,10 C17,6.136 13.864,3 10,3 L10,3 Z",
    id: "Fill-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.0ac215dfdd21311f2b731f9289bb70d3.svg";
export { ForwardRef as ReactComponent };